import React from 'react';
import { FileTextIcon } from 'lucide-react';
export function EmptyState() {
  return <div className="flex flex-col items-center justify-center py-16 px-4 text-center" data-id="element-85">
      <div className="bg-[#F3F3F3] p-4 rounded-full mb-4" data-id="element-86">
        <FileTextIcon className="w-8 h-8 text-[#706E6B]" aria-hidden="true" data-id="element-87" />
      </div>
      <h3 className="text-lg font-semibold text-[#181818] mb-2" data-id="element-88">
        No Documents Available
      </h3>
      <p className="text-sm text-[#444444] max-w-sm" data-id="element-89">
        There are no secure documents associated with this opportunity yet.
      </p>
    </div>;
}